export default "/images/275c99b15159111afbb8a02fd02e3ce0.png";